/**
 * @providesModule Visibility
 *
 */

import {PropsWithChildren} from 'react';

const VisibilityObserver = ({children}: PropsWithChildren) => {
  return children;
};

const Visibility = {
  Observer: VisibilityObserver,
};

export default Visibility;
